let sharedCtx: AudioContext | null = null;
let masterGainNode: GainNode | null = null;

export function getAudioContext(): AudioContext {
  if (!sharedCtx) {
    sharedCtx = new AudioContext();
    // Insert a master gain node between everything and the real destination.
    // Override the destination property so all connect(ctx.destination) calls
    // route through the master gain automatically.
    masterGainNode = sharedCtx.createGain();
    masterGainNode.gain.value = 0.8;
    const realDest = sharedCtx.destination;
    masterGainNode.connect(realDest);
    Object.defineProperty(sharedCtx, 'destination', {
      get: () => masterGainNode as any,
    });
  }
  if (sharedCtx.state === 'suspended') {
    sharedCtx.resume();
  }
  return sharedCtx;
}

/** Returns the master gain node — all tool audio should route through ctx.destination
 *  which we monkey-patch below, but this gives direct access for the volume slider. */
export function getMasterGain(): GainNode {
  getAudioContext(); // ensure initialized
  return masterGainNode!;
}

export function setMasterVolume(value: number): void {
  if (masterGainNode) {
    masterGainNode.gain.setTargetAtTime(value, masterGainNode.context.currentTime, 0.02);
  }
}

export function createReverbBuffer(ctx: AudioContext, duration = 1.5, decay = 2): AudioBuffer {
  const rate = ctx.sampleRate;
  const len = rate * duration;
  const buf = ctx.createBuffer(2, len, rate);
  for (let ch = 0; ch < 2; ch++) {
    const data = buf.getChannelData(ch);
    for (let i = 0; i < len; i++) {
      data[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / len, decay);
    }
  }
  return buf;
}

export function createNoiseBuffer(ctx: AudioContext, duration = 0.5): AudioBuffer {
  const len = ctx.sampleRate * duration;
  const buf = ctx.createBuffer(1, len, ctx.sampleRate);
  const data = buf.getChannelData(0);
  for (let i = 0; i < len; i++) {
    data[i] = Math.random() * 2 - 1;
  }
  return buf;
}

export function createStereoNoiseBuffer(ctx: AudioContext, duration = 1): AudioBuffer {
  const len = ctx.sampleRate * duration;
  const buf = ctx.createBuffer(2, len, ctx.sampleRate);
  for (let ch = 0; ch < 2; ch++) {
    const data = buf.getChannelData(ch);
    for (let i = 0; i < len; i++) {
      data[i] = Math.random() * 2 - 1;
    }
  }
  return buf;
}
